import React from "react";
import { useState, useEffect } from "react";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import {
    Box,
    Chip,
    FormControl,
    FormControlLabel,
    InputLabel,
    MenuItem,
    Select,
    Switch,
    TextField,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import MsgObjetoCreado from "../../componentes/MsgObjetoCreado";
import { useFormik } from "formik";
import * as Yup from "yup";
import axios from "helpers/API";
import FormHelperText from "@material-ui/core/FormHelperText";
import Alert from "@material-ui/lab/Alert";
import SelectFieldMaterialUI from "form/SelectFieldMaterialUI";
import APIMensajeMUI from "componentes/APIMensajeMUI";
import { errorBackendMsg, getValorEditarODefault } from "helpers/helpers";

const useStyles = makeStyles((theme) => ({
    cardCrear: {
        height: 120,
        backgroundColor: theme.palette.secondary.main,
        color: theme.palette.secondary.contrastText,
        "&:hover": {
            backgroundColor: theme.palette.secondary.dark,
            cursor: "pointer",
        },
    },
    inputNuevaBanda: {
        width: "100%",
    },
}));

function BandaHorariaForm({
    drawer,
    bandaEdit,
    keyLista,
    setKeyLista,
    recargarTabla,
    setRecargarTabla,
}) {
    const classes = useStyles();
    const [creado, setCreado] = useState(null);

    // API Mensaje
    const [mensajeError, setMensajeError] = useState("");
    const [showError, setShowError] = useState(false);

    //CAMPOS
    const [servidorOpt, setServidorOpt] = useState([]);
    const [servicioOpt, setServicioOpt] = useState([]);
    const [lugarOpt, setLugarOpt] = useState([]);
    const [diasOpt, setDiasOpt] = useState([
        "Lunes",
        "Martes",
        "Miercoles",
        "Jueves",
        "Viernes",
        "Sabado",
        "Domingo",
    ]);

    ///////

    useEffect(() => {
        listarLugares();
        if (bandaEdit) {
            listarLugares();
            listarServicio(bandaEdit.lugar.value);
            listarServidores(bandaEdit.servicio.value);
        }
    }, []);

    const peticionBase = ({ url, dataRequest = {}, hook = false }) => {
        axios
            .post(url, dataRequest)
            .then(function (response) {
                if (response.data.error) {
                    setShowError(true);
                    setMensajeError(response.data.msg);
                } else {
                    if (Boolean(hook)) {
                        hook(response.data);
                    }
                }
            })
            .catch(function (error) {
                setMensajeError(errorBackendMsg(error));
            });
    };

    const listarLugares = () => {
        let peticion = {
            url: "/generales/lugares/listarPorEtiqueta",
            hook: setLugarOpt,
        };
        peticionBase(peticion);
    };

    const listarServicio = (lugarId) => {
        let peticion = {
            url: "/generales/servicios/listarPorEtiqueta",
            hook: setServicioOpt,
            dataRequest: { lugarId: lugarId },
        };
        peticionBase(peticion);
    };

    const listarServidores = (servicioId) => {
        let peticion = {
            url: "/servidores/listarPorEtiqueta",
            hook: setServidorOpt,
            dataRequest: { servicioId: servicioId },
        };
        peticionBase(peticion);
    };

    const cargaBanda = (values) => {
        const dias = values.dias.map((dia) => {
            return dia.charAt(0).toLowerCase() + dia.slice(1);
        });
        values.dias = dias;

        const handleRespuesta = () => {
            setCreado(true);
            setKeyLista(keyLista + 1);
            setRecargarTabla(true);
        };

        if (bandaEdit) {
            let peticion = {
                url: "/bandasHorarias/editar",
                hook: handleRespuesta,
                dataRequest: { ...values },
            };
            peticionBase(peticion);
        } else {
            let peticion = {
                url: "/bandasHorarias/nuevo",
                hook: handleRespuesta,
                dataRequest: { ...values },
            };
            peticionBase(peticion);
        }
    };

    const validationSchema = Yup.object({
        nombre: Yup.string().required("Campo obligatorio"),
        lugar: Yup.string().required("Campo obligatorio"),
        servicio: Yup.string().required("Campo obligatorio"),
        servidorId: Yup.string().required("Campo obligatorio"),
        horaInicio: Yup.string().required("Campo obligatorio"),
        horaFin: Yup.string().required("Campo obligatorio"),
        dias: Yup.array()
            .min(1, "Seleccione al menos 1 día")
            .required("Campo obligatorio"),
        duracion: Yup.number()
            .typeError("La duración tiene que ser un número")
            .required("Campo obligatorio"),
    });

    const parserDias = (bandaEdit) => {
        return bandaEdit.map((dia) => {
            return dia.charAt(0).toUpperCase() + dia.slice(1);
        });
    };

    const formik = useFormik({
        initialValues: {
            id: getValorEditarODefault(bandaEdit, "id", null),
            activado: getValorEditarODefault(bandaEdit, "activado", true),
            nombre: getValorEditarODefault(bandaEdit, "nombreDeLaBanda", ""),
            lugar: getValorEditarODefault(bandaEdit, "lugar", ""),
            servicio: getValorEditarODefault(bandaEdit, "servicio", ""),
            servidorId: getValorEditarODefault(bandaEdit, "servidor", ""),
            horaInicio: getValorEditarODefault(bandaEdit, "horaInicio", ""),
            horaFin: getValorEditarODefault(bandaEdit, "horaFin", ""),
            dias: bandaEdit ? parserDias(bandaEdit.dias) : [],
            duracion: getValorEditarODefault(bandaEdit, "duracion", ""),
        },
        enableReinitialize: Boolean(bandaEdit) ? true : false,
        validationSchema: validationSchema,
        onSubmit: (values) => {
            cargaBanda(values);
        },
    });

    return (
        <div
            style={{
                margin: "20px",
                maxWidth: "30vw",
                width: "30vw",
            }}
        >
            {creado && (
                <MsgObjetoCreado
                    msg={
                        "La banda horaria ha sido " +
                        (bandaEdit ? "actualizada" : "creada") +
                        " correctamente"
                    }
                    setCreado={setCreado}
                    drawer={drawer}
                />
            )}
            <form onSubmit={formik.handleSubmit}>
                <Box>
                    <Typography variant="h5">
                        {bandaEdit != null ? "Actualizar" : "Nueva"} Banda
                        Horaria
                    </Typography>
                </Box>
                <APIMensajeMUI
                    mt={10}
                    tipo="error"
                    showMensaje={showError}
                    msg={mensajeError}
                />
                {bandaEdit && bandaEdit.tieneProgramacion && (
                    <Box mt={1}>
                        <Alert severity="info">
                            La banda tiene programacion, solo se puede editar el
                            nombre
                        </Alert>
                    </Box>
                )}
                <Box mt={1}>
                    <FormControlLabel
                        mt={10}
                        control={
                            <Switch
                                checked={formik.values.activado}
                                onChange={formik.handleChange}
                                id="activado"
                                name="activado"
                            />
                        }
                        label="Activa"
                    />
                </Box>
                <Box>
                    <TextField
                        variant="outlined"
                        className={classes.inputNuevaBanda}
                        label="Nombre"
                        type="text"
                        id="nombre"
                        name="nombre"
                        value={formik.values.nombre}
                        onChange={formik.handleChange}
                        error={
                            formik.touched.nombre &&
                            Boolean(formik.errors.nombre)
                        }
                        helperText={
                            formik.touched.nombre && formik.errors.nombre
                        }
                    />
                </Box>
                <Box mt={1}>
                    <SelectFieldMaterialUI
                        editar={Boolean(bandaEdit)}
                        classNameFormControl={classes.inputNuevaBanda}
                        disabledFormControl={
                            bandaEdit ? bandaEdit.tieneProgramacion : false
                        }
                        name="lugar"
                        hijosDirectos={["servicio", "servidorId"]}
                        formik={formik}
                        itemsArray={lugarOpt}
                        ejecutarAccion={(id) => {
                            listarServicio(id);
                            // Porque a partir tercer select dependiente no es afectado por el cambio
                            // quedaría si no, con valores viejos
                            setServidorOpt([]);
                        }}
                    />
                </Box>

                <Box mt={1}>
                    <SelectFieldMaterialUI
                        editar={Boolean(bandaEdit)}
                        classNameFormControl={classes.inputNuevaBanda}
                        disabledFormControl={
                            bandaEdit ? bandaEdit.tieneProgramacion : false
                        }
                        name="servicio"
                        hijosDirectos={["servidorId"]}
                        nombreLabel="Servicio"
                        formik={formik}
                        itemsArray={servicioOpt}
                        reiniciarItemsArray={setServicioOpt}
                        ejecutarAccion={(id) => listarServidores(id)}
                        arrayPadreListener={lugarOpt}
                        peticionParaCargarOpcionesAutomatica={(id) =>
                            listarServicio(id)
                        }
                    />
                </Box>

                <Box mt={1}>
                    <SelectFieldMaterialUI
                        editar={Boolean(bandaEdit)}
                        disabledFormControl={
                            bandaEdit ? bandaEdit.tieneProgramacion : false
                        }
                        classNameFormControl={classes.inputNuevaBanda}
                        name="servidorId"
                        nombreLabel="Servidor"
                        formik={formik}
                        itemsArray={servidorOpt}
                        reiniciarItemsArray={setServidorOpt}
                        arrayPadreListener={servicioOpt}
                        peticionParaCargarOpcionesAutomatica={(id) =>
                            listarServidores(id)
                        }
                    />
                </Box>

                <Box mt={2}>
                    <Grid container spacing={1}>
                        <Grid item md={6}>
                            <TextField
                                variant="outlined"
                                disabled={
                                    bandaEdit
                                        ? bandaEdit.tieneProgramacion
                                        : false
                                }
                                id="horaInicio"
                                name="horaInicio"
                                label="Hora Desde"
                                type="time"
                                value={formik.values.horaInicio}
                                className={classes.inputNuevaBanda}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                inputProps={{
                                    step: 300, // 5 min
                                }}
                                onChange={formik.handleChange}
                                error={
                                    formik.touched.horaInicio &&
                                    Boolean(formik.errors.horaInicio)
                                }
                                helperText={
                                    formik.touched.horaInicio &&
                                    formik.errors.horaInicio
                                }
                            />
                        </Grid>
                        <Grid item md={6}>
                            <TextField
                                variant="outlined"
                                disabled={
                                    bandaEdit
                                        ? bandaEdit.tieneProgramacion
                                        : false
                                }
                                id="horaFin"
                                name="horaFin"
                                label="Hora Hasta"
                                type="time"
                                value={formik.values.horaFin}
                                className={classes.inputNuevaBanda}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                inputProps={{
                                    step: 300, // 5 min
                                }}
                                onChange={formik.handleChange}
                                error={
                                    formik.touched.horaFin &&
                                    Boolean(formik.errors.horaFin)
                                }
                                helperText={
                                    formik.touched.horaFin &&
                                    formik.errors.horaFin
                                }
                            />
                        </Grid>
                    </Grid>
                </Box>

                <Box mt={1}>
                    <FormControl
                        variant="outlined"
                        className={classes.inputNuevaBanda}
                        error={
                            formik.touched.dias && Boolean(formik.errors.dias)
                        }
                        disabled={
                            bandaEdit ? bandaEdit.tieneProgramacion : false
                        }
                    >
                        <InputLabel>Días</InputLabel>
                        <Select
                            variant="outlined"
                            label="Días"
                            id="dias"
                            name="dias"
                            multiple
                            value={formik.values.dias}
                            onChange={formik.handleChange}
                            MenuProps={{
                                anchorOrigin: {
                                    vertical: "bottom",
                                    horizontal: "left",
                                },
                                transformOrigin: {
                                    vertical: "top",
                                    horizontal: "left",
                                },
                                getContentAnchorEl: null,
                            }}
                            renderValue={(selected) => (
                                <div>
                                    {selected.map((value) => (
                                        <Chip key={value} label={value} />
                                    ))}
                                </div>
                            )}
                        >
                            {diasOpt.map((dia) => (
                                <MenuItem
                                    style={{ whiteSpace: "normal" }}
                                    key={dia}
                                    value={dia}
                                >
                                    {dia}
                                </MenuItem>
                            ))}
                        </Select>
                        <FormHelperText>
                            {formik.touched.dias && formik.errors.dias}
                        </FormHelperText>
                    </FormControl>
                </Box>
                <Box mt={1}>
                    <TextField
                        variant="outlined"
                        disabled={
                            bandaEdit ? bandaEdit.tieneProgramacion : false
                        }
                        className={classes.inputNuevaBanda}
                        label="Duracion"
                        type="number"
                        id="duracion"
                        name="duracion"
                        value={formik.values.duracion}
                        onChange={formik.handleChange}
                        error={
                            formik.touched.duracion &&
                            Boolean(formik.errors.duracion)
                        }
                        helperText={
                            formik.touched.duracion && formik.errors.duracion
                        }
                    />
                </Box>
                <Box mt={3} style={{ float: "right" }}>
                    <Button type="submit" variant="contained" color="secondary">
                        {bandaEdit ? "Actualizar" : "Crear"}
                    </Button>
                </Box>
            </form>
        </div>
    );
}
export default BandaHorariaForm;
